// ربط صفحة فيسبوك Target Express بالموقع:
//  - زرار عائم «كلّمنا على ماسنجر» + أيقونة الصفحة (الصفحات العامة فقط)
//  - Meta Pixel (لو pixelId متسجّل في /social-config.json) — الصفحات العامة فقط، مش لوحة التحكم
// الإعدادات في public/social-config.json عشان تتغيّر من غير إعادة بناء.
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

type SocialConfig = { facebookUrl?: string; messengerUrl?: string; pixelId?: string };

const DEFAULTS: SocialConfig = {
  facebookUrl: 'https://www.facebook.com/targetexpress',
  messengerUrl: 'https://m.me/targetexpress',
  pixelId: '',
};

const PUBLIC_PREFIXES = ['/about', '/support', '/contact', '/pricing', '/track', '/feedback', '/faq', '/register', '/login'];
export function isPublicPath(p: string) {
  return p === '/' || PUBLIC_PREFIXES.some((x) => p === x || p.startsWith(x + '/'));
}

let cfgPromise: Promise<SocialConfig> | null = null;
function loadConfig(): Promise<SocialConfig> {
  if (!cfgPromise) {
    cfgPromise = fetch('/social-config.json', { cache: 'no-cache' })
      .then((r) => (r.ok ? r.json() : {}))
      .then((j) => ({ ...DEFAULTS, ...(j || {}) }))
      .catch(() => DEFAULTS);
  }
  return cfgPromise;
}

declare global {
  interface Window { fbq?: any; _fbq?: any }
}

function initPixel(id: string) {
  if (!/^\d{6,20}$/.test(id) || window.fbq) return;
  const n: any = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  window.fbq = n; window._fbq = n;
  n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  window.fbq('init', id);
}

export function trackPixel(event: string, data?: Record<string, unknown>) {
  try { window.fbq?.('track', event, data); } catch { /* ignore */ }
}

export default function FacebookConnect() {
  const { pathname } = useLocation();
  const [cfg, setCfg] = useState<SocialConfig | null>(null);
  const pub = isPublicPath(pathname);

  useEffect(() => { loadConfig().then(setCfg); }, []);

  useEffect(() => {
    if (!cfg || !pub || !cfg.pixelId) return;
    initPixel(cfg.pixelId);
    trackPixel('PageView');
  }, [cfg, pub, pathname]);

  if (!pub || !cfg) return null;
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3" dir="rtl">
      {cfg.facebookUrl && (
        <a href={cfg.facebookUrl} target="_blank" rel="noopener noreferrer" aria-label="صفحتنا على فيسبوك"
          className="flex h-11 w-11 items-center justify-center rounded-full bg-[#1877F2] text-white shadow-lg transition hover:scale-105">
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
            <path d="M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5h1.5V4.4c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2.4H8v3h2.6V21h2.9z" />
          </svg>
        </a>
      )}
      {cfg.messengerUrl && (
        <a href={cfg.messengerUrl} target="_blank" rel="noopener noreferrer"
          onClick={() => trackPixel('Contact', { method: 'messenger' })}
          className="flex items-center gap-2 rounded-full bg-gradient-to-l from-[#0099FF] to-[#A033FF] px-4 py-3 text-sm font-bold text-white shadow-lg transition hover:scale-105">
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
            <path d="M12 2C6.4 2 2 6.1 2 11.6c0 2.9 1.2 5.4 3.1 7.1V22l2.9-1.6c1.2.3 2.6.5 4 .5 5.6 0 10-4.1 10-9.6S17.6 2 12 2zm1 12.9-2.5-2.7-5 2.7 5.5-5.8 2.6 2.7 4.9-2.7-5.5 5.8z" />
          </svg>
          كلّمنا على ماسنجر
        </a>
      )}
    </div>
  );
}
